module.exports = __webpack_public_path__ + "img/what3.6a014895.png";